export enum UserType {
  Cargill = 'cargill',
  SuperUser = 'superuser',
  Customer = 'customer',
}
